<div class="modal-content">
  <div class="container-fluid">
    <br /><br /><br /><br />
    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript: void(0);">Home</a></li>
              <li class="breadcrumb-item active">Dashboard</li>
            </ol>
          </div>
          <h4 class="page-title">Merchant Management Audit</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->

    <div class="row" id="content" #content>
      <div class="col-12">
        Audit trail for Merchant number: <b>{{merchantNumber}}</b>
        <div class="card-box">
          <ul ngbNav #nav="ngbNav" class="nav nav-tabs">
            <li [ngbNavItem]="1">
              <a ngbNavLink>Merchant details</a>
              <ng-template ngbNavContent>
                <app-audit-merchant-details [merchantNumber]="merchantNumber"></app-audit-merchant-details>
              </ng-template>
            </li>
            <li [ngbNavItem]="2">
              <a ngbNavLink>Banking details</a>
              <ng-template ngbNavContent>
                <app-audit-bank-details [merchantNumber]="merchantNumber"></app-audit-bank-details>
              </ng-template>
            </li>
            <li [ngbNavItem]="3">
              <a ngbNavLink>Contact details</a>
              <ng-template ngbNavContent>
                <app-audit-contact-details [merchantNumber]="merchantNumber"></app-audit-contact-details>
              </ng-template>
            </li>
            <li [ngbNavItem]="4">
              <a ngbNavLink>Commission details</a>
              <ng-template ngbNavContent>
                <app-audit-commission-details [merchantNumber]="merchantNumber"></app-audit-commission-details>
              </ng-template>
            </li>
            <li [ngbNavItem]="5" hidden="hidden">
              <a ngbNavLink>VAS Customer details</a>
              <ng-template ngbNavContent>
                <app-audit-vas-customer-details [merchantNumber]="merchantNumber"></app-audit-vas-customer-details>
              </ng-template>
            </li>
            <li [ngbNavItem]="6">
              <a ngbNavLink>VAS details</a>
              <ng-template ngbNavContent>
                <app-audit-vas-details [merchantNumber]="merchantNumber"></app-audit-vas-details>
              </ng-template>
            </li>
            <li [ngbNavItem]="7">
              <a ngbNavLink>Sink node mapped fields</a>
              <ng-template ngbNavContent>
                <app-audit-sink-node-mapped-fields [merchantNumber]="merchantNumber"></app-audit-sink-node-mapped-fields>
              </ng-template>
            </li>
            <li [ngbNavItem]="8">
              <a ngbNavLink>Structural data</a>
              <ng-template ngbNavContent>
                <app-audit-structural-data-details [merchantNumber]="merchantNumber"></app-audit-structural-data-details>
              </ng-template>
            </li>
            <li [ngbNavItem]="9">
              <a ngbNavLink>Mapped SD Tag</a>
              <ng-template ngbNavContent>
                <app-audit-packed-structural-data-details [merchantNumber]="merchantNumber"></app-audit-packed-structural-data-details>
              </ng-template>
            </li>
            <li [ngbNavItem]="10">
              <a ngbNavLink>Merchant Params</a>
              <ng-template ngbNavContent>
                <app-audit-merchant-params-data-details [merchantNumber]="merchantNumber"></app-audit-merchant-params-data-details>
              </ng-template>
            </li>
          </ul>

          <div [ngbNavOutlet]="nav" class="tab-pane">
          </div>

        </div>
      </div>
    </div>
    <!-- end -->

  </div>
</div>
